import { render, staticRenderFns } from "./nhPop.vue?vue&type=template&id=1b97e217&"
import script from "./nhPop.vue?vue&type=script&lang=js&"
export * from "./nhPop.vue?vue&type=script&lang=js&"
import style0 from "./nhPop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports